import { DialogView, DialogSize } from "@/components/atoms/dialog";
import { ItemDetailsMobile } from "@/components/atoms/itemDetailsMobile";
import { useIntl } from "react-intl";
import { ItemDetailsDialogMobileProps } from "./types";

export const ItemDetailsDialogMobile = (
	props: ItemDetailsDialogMobileProps
) => {
	const { titleKey, itemProps, itemActions, open, setOpen } = props;
	const intl = useIntl();

	return (
		<DialogView
			content={
				itemProps ? (
					<ItemDetailsMobile itemProps={itemProps} actions={itemActions} />
				) : (
					<></>
				)
			}
			title={intl.formatMessage({
				id: titleKey,
			})}
			open={open}
			setOpen={setOpen}
			size={DialogSize.Small}
		/>
	);
};
